import {PLAYER_COLORS, checkIfLowVisibilityPlayerColor} from "../../configs/colors";
import {SPECTATOR_COLOR} from "../../constants/players";
import {checkIfPlayerColorsSimilar} from "../../configs/similarPlayerColors";
import {getRandomElement} from "../other/getRandomElement";

// Все цвета, которые можно выдать игроку: служебные (нейтральный, зрительский)
// в раздачу не идут
export const ASSIGNABLE_PLAYER_COLORS = Object.values(PLAYER_COLORS).filter(
  (color) => color !== PLAYER_COLORS.NEUTRAL && color !== SPECTATOR_COLOR
);

/**
 * Цвет игрока при старте партии. Общий алгоритм для онлайн-игр (server/index.js)
 * и локальных (applyFactionColorsToLocalGame) — игроки обрабатываются по
 * очереди, каждый следующий видит цвета уже обслуженных в usedColors:
 *
 *  1) первый цвет из приоритетов фракции/скина, который свободен И не похож ни
 *     на один уже занятый (см. SIMILAR_PLAYER_COLOR_PAIRS);
 *  2) если все приоритетные отпали — случайный из оставшихся свободных: в
 *     первую очередь из непохожих на занятые и заметных на поле (см.
 *     LOW_VISIBILITY_PLAYER_COLORS), затем из любых непохожих на занятые;
 *  3) если свободных цветов не осталось вовсе — запасной (цвет поля).
 *
 * @param {string[]} preferredColors - приоритетные цвета скина и фракции
 * @param {Set<string>} usedColors - цвета, уже выданные другим игрокам
 * @param {string} fallbackColor - цвет игрока в конфигурации поля
 * @returns {string} цвет игрока
 */
export const pickPlayerColor = (preferredColors, usedColors, fallbackColor) => {
  const isFree = (color) => Boolean(color) && !usedColors.has(color);
  const isSimilarToUsed = (color) => [...usedColors].some(
    (usedColor) => checkIfPlayerColorsSimilar(color, usedColor)
  );

  const preferredColor = (preferredColors || []).find(
    (color) => isFree(color) && !isSimilarToUsed(color)
  );
  if (preferredColor) {
    return preferredColor;
  }

  const freeColors = ASSIGNABLE_PLAYER_COLORS.filter(isFree);
  const freeNotSimilarColors = freeColors.filter((color) => !isSimilarToUsed(color));
  const freeVisibleColors = freeNotSimilarColors.filter((color) => !checkIfLowVisibilityPlayerColor(color));
  if (freeVisibleColors.length > 0) {
    return getRandomElement(freeVisibleColors);
  }
  if (freeNotSimilarColors.length > 0) {
    return getRandomElement(freeNotSimilarColors);
  }
  if (freeColors.length > 0) {
    return getRandomElement(freeColors);
  }

  return fallbackColor;
};
